import { module } from 'stereomodularjs';
import Vue from 'vue';
import { compileToFunctions } from 'vue-template-compiler';
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import JSEncrypt from "jsencrypt";


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Get next tag stereo after this.el and store it
        const template = this.el.nextElementSibling;
        const encryption_key = this.el.getAttribute('data-key');
        template.remove();
        this.initVUE(template, encryption_key);
    }

    initVUE(template, publicKey) {
        Vue.config.devtools = true;
        Vue.config.productionTip = false;
        //Cast template as string
        template = template.innerHTML;
        const res = compileToFunctions(template);
        const app = new Vue({
            el: this.el,
            data: {
                groups: [],
                kids : [],
                isSubmitting: false,
                error: '',
                tab: 'general',
                currentKid: 0,
                form:{
                    parents: [{
                        name: '',
                        address: '',
                        city: '',
                        zip: '',
                        phone_1: '',
                        phone_2: '',
                        phone_3: '',
                        email: '',
                        authorize_parent: false,
                        infolettre: true,
                        relever_31: false,
                        contract: false,
                        secure: null,
                    }],
                    authorize_takers: [],
                    password: '',
                }
            },
            validations () {
                return {
                    kids: {
                        $each: {
                            first_name: { required },
                            last_name: { required },
                            group: { required },
                            weeks: { required }
                        }
                    },
                    form: {
                        parents: {
                            $each: {
                                name: { required },
                                address: { required },
                                city: { required },
                                zip: { required },
                                phone_1: { required },
                                email: { required, email }
                            }
                        }
                    }
                }
            },
            setup() {
                return { v$: useVuelidate() }
            },
            methods: {
                async nextStep(){
                    //Validate form
                    if(this.tab == 'general'){
                        this.tab = 'authorization';
                    } else if(this.tab == 'authorization'){
                        this.tab = 'kids';
                    }
                    document.getElementById('inscription').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                },
                async fetchGroups() {
                    //axios GET /wp-json/cdj/v1/groups
                    return axios.get('/wp-json/cdj/v1/groups?'+Math.random().toString(36).substring(2,7))
                        .then((response) => {
                            this.groups = response.data;
                            return response.data;
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                },
                addAuthorizeTaker(){
                    this.form.authorize_takers.push({
                        name: '',
                        phone: '',
                        urgence: false,
                        taker: false,
                    });
                },
                removeTaker(index){
                    this.form.authorize_takers.splice(index, 1);
                },
                addParent(){
                    this.form.parents.push({
                        name: '',
                        address: '',
                        city: '',
                        zip: '',
                        phone_1: '',
                        phone_2: '',
                        phone_3: '',
                        email: '',
                        authorize_parent: false,
                        infolettre: true,
                        relever_31: false,
                        contract: false,
                        secure: null,
                    });
                },
                removeParent(index){
                    this.form.parents.splice(index, 1);
                },
                addChildren(){
                    const response = this.validate();
                    if(!response) {
                        alert('Veuillez remplir tous les champs obligatoires.');
                        return;
                    }

                    this.kids.push({
                        first_name: '',
                        last_name: '',
                        group: '',
                        secure: null,
                        weeks: [],
                        error: '',
                        maternelle: '',
                        temperament: [],
                        particularites: [],
                        dispositions: [],
                        adrenaline: '',
                        precision_sante: '',
                        birthdate: '',
                    });

                    this.currentKid = this.kids.length - 1;
                    //Scroll to #kid
                    document.getElementById('inscription').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

                },
                removeChildren(index){
                    this.kids.splice(index, 1);
                    this.currentKid = this.kids.length - 1;
                },
                getWeeks(group){
                    //Get weeks from groups array with term_id == group
                    let weeks = this.groups.filter(function (el) {
                        return el.term_id == group;
                    });
                    //Return weeks array
                    return weeks[0].weeks;
                },
                getStatus(week){
                    const count  = week.count;
                    const max    = week.metadata.total_place;

                    if(count >= max){
                        return 'Complet';
                    } //else if 75% of max return Places limitées
                    else if(count >= (max * 0.75)){
                        return 'Places limitées';
                    } //else return Places disponibles
                    else {
                        return 'Disponibles';
                    }
                },
                weekDateFormatted(week){
                    //Exemple 1er au 5 juillet from start_date to end_date
                    let start = new Date(week.metadata.start_date+'T00:00:00');
                    let end = new Date(week.metadata.end_date+'T00:00:00');
                    let options = {month: 'long', day: 'numeric' };
                    if(start.getMonth() == end.getMonth()){
                        return start.getDate() + ' au ' + end.getDate() + ' ' + start.toLocaleDateString('fr-FR', { month: 'long' });
                    }

                    return start.toLocaleDateString('fr-FR', options) + ' au ' + end.toLocaleDateString('fr-FR', options);
                },
                selectWeek(week, index){
                    //Check if week is already selected
                    if(this.kids[index].weeks.includes(week.term_id)){
                        //Remove week from array
                        const i = this.kids[index].weeks.indexOf(week.term_id);
                        this.kids[index].weeks.splice(i, 1);
                    } else {
                        //Add week to array
                        this.kids[index].weeks.push(week.term_id);
                    }
                },
                validate(){
                    //Check if at least one kid has first_name, last_name, group and at least one week selected. If more than one kid, check if at least one kid has first_name, last_name, group and at least one week selected.
                    this.error = '';
                    let valid = true;
                    let kids = this.kids;
                    kids.forEach(function(kid){
                        if(kid.first_name == '' || kid.last_name == '' || kid.group == '' || kid.weeks.length == 0){
                            valid = false;
                        }
                    });

                    if(valid){
                        return true;
                    } else {
                        return false
                    }
                },
                testEncryption(encrypt){
                    let rsa = new JSEncrypt();
                    rsa.setPublicKey(publicKey);
                    let secure = rsa.encrypt(encrypt);
                    console.log(secure);
                },
                async addToCart() {
                    this.isSubmitting = true;
                    let app = this;
                    const validate = await this.validate();

                    if(!validate){
                        this.error = "Veuillez sélectionner au moins une semaine.";
                        this.isSubmitting = false;
                        return;
                    }

                    let groups = await this.fetchGroups();

                    const rsa = new JSEncrypt();
                    rsa.setPublicKey(publicKey);
                    //for all kids encrypt secure field
                    for(let i = 0; i < this.kids.length; i++){
                        let kid = this.kids[i];
                        if(kid.secure != null){
                            let encryptedNAS = rsa.encrypt(kid.secure);
                            this.kids[i].secure = encryptedNAS;
                        }
                    }

                    //for all parents encrypt secure field
                    for(let i = 0; i < this.form.parents.length; i++){
                        let parent = this.form.parents[i];
                        if(parent.secure != null){
                            let encryptedNAS = rsa.encrypt(parent.secure);
                            this.form.parents[i].secure = encryptedNAS;
                        }
                    }

                    //Foreach kid, add to cart
                    this.kids.forEach(async function(kid, index){
                        let metadata = {
                            form: app.form,
                            kid_form: kid,
                            first_name: kid.first_name,
                            last_name: kid.last_name,
                            group: {
                              id: kid.group,
                              name: groups.filter(function (el) {
                                return el.term_id == kid.group;
                              })[0].name
                            },
                            weeks: kid.weeks
                          };
                        
                          //Get weeks name from term_id and remove 'Semaine' from name
                            let weeks = [];
                            let totalPrice = 0;
                            kid.weeks.forEach(function(week){

                                groups.forEach(function (el) {
                                    el.weeks.forEach(function (el) {
                                        if(el.term_id == week){
                                            //Check if week count is less than metadata.total_place
                                            if(el.count >= el.metadata.total_place){
                                                app.error = 'Une ou plusieurs semaines sélectionnées sont complètes. Veuillez en sélectionner d\'autres.';
                                                app.isSubmitting = false;
                                                return;
                                            }
                                            weeks.push(el.name.replace('Semaine ', ''));
                                            totalPrice += parseFloat(el.metadata.price);
                                        }
                                    });
                                });

                            });
                            //Foreach kid 
                            let uniqueId = Math.floor(Math.random() * 1000000) + 1;
                            if(app.error != ''){
                                return;
                            }

                            setTimeout(async function() {
                                await window.StereoStoreAddToCart({
                                    id: uniqueId,
                                    type: 'cdj',
                                    quantity: 1,
                                    name: 'Camp de jour (repas)',
                                    description: 'Semaine ' + weeks.join(', '),
                                    price: totalPrice,
                                    metadata: JSON.stringify(metadata)
                                }).then(function(response){
                                    //if last kid, redirect to cart
                                    if(kid == app.kids[app.kids.length - 1]){
                                        app.isSubmitting = false;
                                        window.location.href = '/panier/';
                                    }
                                });
                            }, 1000 * index);

                    });
                    this.isSubmitting = false;
                }
            },
            ...res,
            mounted() {
                this.fetchGroups();
                this.kids.push({
                    first_name: '',
                    last_name: '',
                    group: '',
                    weeks: [],
                    temperament: [],
                    particularites: [],
                    dispositions: [],
                    adrenaline: '',
                    precision_sante: '',
                    birthdate: '',
                    secure: null,
                });
            }
        })
    }
}